import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useGetPromotion } from "../../api/hooks/usePromotion";

const ViewPromotion = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const promotionId = location.state?.id;

  const { data: promotionData, isLoading, error } = useGetPromotion(promotionId, {
      enabled: !!promotionId
  });

  if (isLoading) {
      return (
          <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
              <CircularProgress />
          </Box>
      );
  }

  if (error || !promotionData?.data) {
       return (
          <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
              <p>Error loading promotion.</p>
          </Box>
      );
  }

  const promo = promotionData.data;

  return (
    <>
      <div className="main_title">
        <h1>Promotion Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-promotions")}>
            Promotion Management
          </button>{" "}
          - Promotion Detail
        </p>
      </div>

      <div className="cards view_page">
          <div className="section_title">
            <h2>Promotion Info</h2>
          </div>
          <div className="gap_p">
            <div className="vew_img v2 no_radius w_100">
              <h6>Image</h6>
              <figure>
                <img src={promo.image || "/static/images/placeholder.png"} alt="Promotion" />
              </figure>
            </div>
            <div className="w_100">
              <h6>Redirection Link</h6>
              <p>
                 <a href={promo.redirectUrl} target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'underline' }}>
                      {promo.redirectUrl}
                  </a>
              </p>
            </div>
          </div>
      </div>
    </>
  );
};

export default ViewPromotion;
